













































import { Component, Prop, Vue } from "vue-property-decorator";
//  components
import DataIndicator from "./DataIndicator.vue";
//  types
import { CellData, IndicatorData } from "@/types/VDataTable";

@Component({
  components: {
    DataIndicator,
  },
})
export default class DataCell extends Vue {
  @Prop({ type: Object }) data!: CellData;

  showAlertTooltip = false;

  //  @Getters
  get isIndicator(): boolean {
    if (!this.data) return false;
    return this.data.type.includes("indicator");
  }

  get IndicatorData(): IndicatorData | undefined {
    if (!this.isIndicator) return;
    return {
      column: this.data.column,
      vesselId: this.data.vesselId,
      vesselName: this.data.vesselName,
      status: this.data.value,
      type: this.data.type,
      text: this.indicatorText,
      icon: this.indicatorIcon,
      align: this.data.align,
      link: null,
      criticalList: this.data.criticalList,
      warningList: this.data.warningList,
      missingPosition: this.data.missingPosition,
    };
  }

  get indicatorText(): string {
    if (this.data.type.includes("performance")) {
      if (this.data.value === "Ok") return "Okay";
      else if (this.data.value === "Observe") return "Observe";
      else if (this.data.value === "NotOk") return "Not Okay";
      else if (this.data.value === "BenchMarking") return "Benchmarking";
      else return "N/A";
    } else if (this.data.type.includes("alert")) {
      if (this.data.value === 0) return "No Alerts";
      return "Not Available";
    } else {
      return this.data.value ? this.data.value.toString() : "";
    }
  }

  get indicatorIcon(): string {
    if (this.data.type.includes("performance")) {
      if (this.data.value === "Ok") return "$StatusOk";
      else if (this.data.value === "Observe") return "$StatusObserve";
      else if (this.data.value === "NotOk") return "$StatusNotOk";
      else if (this.data.value === "BenchMarking") return "$StatusBenchmarking";
      else return "";
    } else {
      return "";
    }
  }

//  @Methods
}
